import { Injectable } from '@angular/core';
import { CampaignContentService } from '@challenger/care/services/campaign-content.service';
import { ANALYTICS } from '@challenger/care/services/care-analytics.service';
import { Apollo } from 'apollo-angular';
import {
  GET_ALL_DASHBOARD_ARTICLES,
  GET_ALL_FAULT_ARTICLES,
  GET_ALL_SEO_LANDING_PAGES,
  GET_ALL_SEO_LANDING_PAGES_SCULLY_URLS,
  GET_ALL_SEO_LANDING_PAGE_BY_UID_PREFIX,
} from './seo-strapi.queries';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SEOStrapiService {
  constructor(private apollo: Apollo, private campaignContentService: CampaignContentService, private router: Router) {}

  getContent(prefixUid: string = '', pageuid: any) {
    if (pageuid) {
      pageuid = this.campaignContentService.getStrapiUID(pageuid);
      if (!ANALYTICS.STRAPIUID) {
        ANALYTICS.STRAPIUID = pageuid;
      }

      return this.apollo.watchQuery({
        query: GET_ALL_SEO_LANDING_PAGE_BY_UID_PREFIX,
        variables: {
          pageuid,
          prefixUid,
          publicationState: environment.previewDraftArticles ? 'PREVIEW' : 'LIVE',
        },
      }).valueChanges;      
      // .pipe(
      //   catchError((error) => {
      //     console.error('Error reported loading Strapi article:', error);
      //     this.router.navigate(['./page-not-found']);
      //  })
      // );
    }
  }

  getPageUrls() {
    return this.apollo.watchQuery({
      query: GET_ALL_SEO_LANDING_PAGES_SCULLY_URLS,
      variables: {
        publicationState: environment.previewDraftArticles ? 'PREVIEW' : 'LIVE',
      },
    }).valueChanges;
  }

  getAllDashboardArticles() {
    return this.apollo.watchQuery({
      query: GET_ALL_DASHBOARD_ARTICLES,
      fetchPolicy: 'no-cache',
      variables: {        
        publicationState: environment.previewDraftArticles ? 'PREVIEW' : 'LIVE',
      },
    }).valueChanges;
  }

  getAllFaultArticles() {
    return this.apollo.watchQuery({
      query: GET_ALL_FAULT_ARTICLES,
      fetchPolicy: 'no-cache',
      variables: {        
        publicationState: environment.previewDraftArticles ? 'PREVIEW' : 'LIVE',
      },
    }).valueChanges;
  }

  getAllSEOLandingPages() {
    return this.apollo.watchQuery({
      query: GET_ALL_SEO_LANDING_PAGES, 
      fetchPolicy: 'no-cache',
      variables: {        
        publicationState: environment.previewDraftArticles ? 'PREVIEW' : 'LIVE',
      },
    }).valueChanges;
  }
}
